<template>
    <div class="woman-body">
        <!--顶部-->
        <div class="woman-top" v-show="book_cate_woman.length>0">
            <div class="top-title">{{$t("womanlabel")}}</div>
            <div class="top-item top-itemwoman" @click="go.goSearch(item.id)" v-for="(item,index ) in book_cate_woman" :key="index">
                <div class="item-img">
                    <img :src="item.img">
                </div>
                <div class="item-info">
                    <div class="info-title">{{item.name}}</div>
                    <!-- <div class="info-fonts" v-html="item.remark"></div> -->
                </div>
            </div>
        </div>
        <!--顶部-->
        <div class="woman-top" v-show="book_cate_man.length>0">
            <div class="top-title">{{$t("man")}}</div>
            <div class="top-item top-itemman"  @click="go.goSearch(item.id)" v-for="(item,index ) in book_cate_man" :key="index">
                <div class="item-img">
                    <img :src="item.img">
                </div>
                <div class="item-info">
                    <div class="info-title">{{item.name}}</div>
                    <!-- <div class="info-fonts" v-html="item.remark"></div> -->
                </div>
            </div>
        </div>
        <!--内容区域-->
        <div class="content-area">
            <div class="con-cate">
                <div class="con-top">
                    <div class="con-title">{{news_list.text}}</div>
                    <div class="con-more" @click="go.goMore(news_list.type,news_list.text)">{{$t("more")}}</div>
                </div>
                <div class="con-con">
                    <div class="con-item" v-for="(item,index2) in news_list.list" v-bind:key="index2">
                        <img @click="go.goDetail(item.id)" :src="item.img">
                        <div @click="go.goDetail(item.id)" class="con-name">{{item.title}}</div>
                    </div>
                </div>
            </div>
            <div class="con-cate">
                <div class="con-top">
                    <div class="con-title">{{$t("woman")}}</div>
                    <div class="con-more" @click="go.goMore(hots_list.type,$t('woman'))">{{$t("more")}}</div>
                </div>
                <div class="con-con" >
                    <div class="con-item" v-for="(item,index2) in hots_list.list" v-bind:key="index2">
                        <img @click="go.goDetail(item.id)" :src="item.img">
                        <div @click="go.goDetail(item.id)" class="con-name">{{item.title}}</div>
                    </div>
                </div>
            </div>
        </div>
        <!--底部-->
        <pagebottom></pagebottom>
    </div>
</template>

<script>
import pagebottom from "@/components/common/pagebottom";
export default {
  name: "channel",
  components: {
    pagebottom
  },
  props:{
    sex:Number
  },
  data() {
    return {
      book_cate_man: [],
      book_cate_woman: [],
      hots_list: [],
      news_list: []
    };
  },
  mounted: function() {
    this.getLists();
  },
  // filters:{
  //   remark:function(remark){
  //     remark = remark.replace(/[，,\|]/g, "|");
  //     return remark;
  //   }
  // },
  methods: {
    //获取首页列表
    getLists() {
      this.$indicator.open({
        text: "Loading...",
        spinnerType: "fading-circle"
      });
      this.req.channel(this.sex).then(res => {
        this.$indicator.close();
        for(var i=0;i<res.data.book_cate.length;i++){
          res.data.book_cate[i].remark = res.data.book_cate[i].remark.replace(/[\s。]/g, "");
          res.data.book_cate[i].remark = "<p>|"+res.data.book_cate[i].remark.replace(/[，、\. 。,\|]/g, "|</p><p>|")+"|</p>";
          if(res.data.book_cate[i].sex==0){
            this.book_cate_woman.push(res.data.book_cate[i]);
          }else{
            this.book_cate_man.push(res.data.book_cate[i]);
          }
        }
        this.hots_list = res.data.hots_list;
        this.news_list = res.data.news_list;
      });
    },
  }
};
</script>

<style scoped>

.top-title{
  font-size: 0.4rem;
  background: #ffffff;
  padding: 0 0.1rem 0.3rem;
}
.woman-body {
  position: absolute;
  left: 0;
  top: 0;
  background: #f2f2f2;
}
.woman-top {
  width: 100%;
  padding: 0.2rem;
  box-sizing: border-box;
  height: auto;
  background: #ffffff;
}
.top-item {
  width: 3.4rem;
  height: 1.8rem;
  background: #fff0f1;
  box-sizing: border-box;
  padding: 0.2rem 0 0.2rem 0.4rem;
  display: flex;
  float: left;
  margin: 0 0.2rem 0.2rem 0.04rem;
}
.top-item:nth-child(2n) {
  margin-right: 0;
}
.top-itemwoman:nth-child(4n+1) {
  background-color: #fff;
}
.top-itemwoman:nth-child(3n+1) {
  border-right:0.04rem solid #fff0f1;
}
.top-itemwoman:nth-child(4n+0) {
  background-color: #fff;
}
.top-itemman{
  background-color: #fafafa;
}
.top-itemman:nth-child(4n+1) {
  background-color: #fff;
}
.top-itemman:nth-child(3n+1) {
  border-right:0.04rem solid #fafafa;
}
.top-itemman:nth-child(4n+0) {
  background-color: #ffffff;
} 
.item-img {
  width: 1rem;
  height: 1.4rem;
  overflow: hidden;
}
.item-img img {
  display: block;
    width: auto;
  height: 1.4rem;
}
.item-info {
  padding-left: 0.34rem;
}
.info-fonts {
  max-width: 1.8rem;
  font-size: 0.2rem;
  line-height: 0.35rem;
  color: #666666;
  text-align: center;
  margin-bottom: 0.06rem;
}
.info-title {
  font-size: 0.3rem;
  line-height: 1.4rem;
  padding: 0 0 0.1rem;
  font-weight: 700;
  color: #000000;
}
.info-woman-bg{
  background-color: #fff0f1;
}
.info-man-bg{
  background-color: #fafafa;
}
/*内容分类区域*/
.content-area {
  width: 100%;
  height: auto;
}
.con-cate {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 0.4rem 0 0 0.4rem;
  background: #ffffff;
  margin-bottom: 0.16rem;
}
.con-cate:last-child {
  margin-bottom: 0;
  padding-bottom: 0.18rem;
}
.con-top {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.4rem 0.18rem 0;
  display: flex;
  justify-content: space-between;
}
.con-title,
.con-more {
  color: #ff1f4f;
}
.con-title {
  font-size: 0.3rem;
  line-height: 0.3rem;
}
.con-more {
  font-size: 0.2rem;
  line-height: 0.2rem;
  padding-top: 0.1rem;
}
.con-con {
  overflow: hidden;
}
.con-item {
  width: 1.82rem;
  height: auto;
  float: left;
  margin-right: 0.62rem;
  padding-top: 0.1rem;
}
.con-item:nth-child(3n) {
  margin-right: 0;
}
.con-item img {
  display: block;
  width: 1.82rem;
  height: 2.56rem;
}
.con-name {
  width: 1.82rem;
  height: auto;
  font-size: 0.26rem;
  margin: 0.24rem 0 0.4rem;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/index/channel.vue